<script>
export default {
  name: "DropList",
  directives: {
    close: {
      inserted(el, binding, vnode) {
        window.addEventListener("click", (e) => {
          if (!el.contains(e.target)) vnode.context.dropListIsShow = false;
        });
      },
    },
  },
  props: {
    dropOption: {
      type: Array,
      default: () => [],
    },
    selectedName: {
      type: String,
      default: "",
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dropListIsShow: false,
    };
  },
  computed: {
    currentValObj() {
      return (
        this.dropOption?.length > 0 &&
        this.dropOption.filter(
          (item, idx) => item.label === this.selectedName
        )[0]
      );
    },
    currentIndex() {
      return (
        this.dropOption?.length > 0 &&
        this.dropOption.findIndex((item) => item.label === this.selectedName)
      );
    },
  },
  watch: {
    // dropListIsShow(newVal) {
    //   if (newVal) {
    //     this.$nextTick(() => {
    //       setTimeout(() => {
    //         const scrollIdx =
    //           this.currentIndex === 0 ? 0 : this.currentIndex - 1;
    //         const activeDom = document.querySelector(
    //           `.drop-list-item-${scrollIdx}`
    //         );
    //         const parent = document.querySelector(".drop-list");
    //         // if (scrollIdx != 0) parent.scrollIntoView({ behavior: 'smooth', block: 'start' })
    //         scrollIdx == 0
    //           ? parent.scrollTo({ top: 0, behavior: "smooth" })
    //           : activeDom.scrollIntoView({
    //               behavior: "smooth",
    //               block: "start",
    //             });
    //       }, 200);
    //     });
    //   }
    // },
  },
  methods: {
    onDropBarClick() {
      this.dropListIsShow = !this.dropListIsShow;
      this.$emit("onDropBarClick", this.dropListIsShow);
    },
    onDropClick(v) {
      this.$emit("onDropClick", v);
      this.dropListIsShow = false;
    },
  },
};
</script>

<template>
  <div v-close class="drop-list-container">
    <div
      class="drop-bar"
      :class="{ 'drop-bar--active': isActive }"
      @click="onDropBarClick"
    >
      <!-- <p class="h-line-1 drop-title">{{ currentValObj.label || '请选择' }}</p> -->
      <p class="drop-title">2024百部课件下基层</p>
      <i
        class="el-icon-caret-right"
        :class="{ 'icon-rotate': dropListIsShow }"
      />
    </div>
    <Transition name="drop-list">
      <div v-show="dropListIsShow" class="drop-list">
        <div
          v-for="(v, i) in dropOption"
          :key="v.label"
          class="drop-list-item"
          :class="[
            { 'drop-list-item-active': i === currentIndex },
            `drop-list-item-${i}`,
          ]"
          @click="onDropClick(v)"
        >
          <p class="item-title">{{ v.label }}</p>
          <i class="el-icon-arrow-right" />
        </div>
      </div>
    </Transition>
  </div>
</template>

<style lang="scss" scoped>
.drop-list-container {
  height: 55px;
  position: relative;
  user-select: none;
  .drop-list {
    position: absolute;
    left: -20px;
    bottom: 80px;
    width: 660px;
    height: 390px;
    background-color: #feeac0;
    border-radius: 15px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 10px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #9f9f9f;
      border-radius: 3px;
    }
    // &::-webkit-scrollbar { // chrome/safari
    //   display: none;
    // }
    // scrollbar-width: none; // firefox
    // -ms-overflow-style: none; // IE10+
    z-index: 3;
    .drop-list-item {
      flex-shrink: 0;
      width: 100%;
      min-height: 50px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      column-gap: 30px;
      padding: 10px;
      box-sizing: border-box;
      cursor: pointer;
      .item-title {
        width: 100%;
        font-size: 17px;
        font-weight: bold;
        color: #d02603;
      }
      .el-icon-arrow-right {
        font-size: 16px;
        color: #333;
      }
    }
    .drop-list-item-active {
      background-color: #e83706;
      .item-title,
      .el-icon-arrow-right {
        color: #fff;
      }
    }
  }
}
.drop-bar {
  position: absolute;
  z-index: 6;
  top: 0;
  bottom: 0;
  width: 170px;
  min-height: 55px;
  text-align: center;
  background-color: none;
  border-radius: 30px;
  padding: 5px 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #fff8c1;
  .drop-title {
    font-size: 17px;
    text-decoration: underline;
  }
  .el-icon-caret-right {
    font-size: 20px;
    transition: transform linear 0.1s;
  }
  .icon-rotate {
    transform: rotate(-90deg);
  }
}
.drop-bar--active {
  background-color: #fff5aa;
  color: #d20508;
  .drop-title {
    text-decoration: none;
  }
}

.drop-list-enter-active,
.drop-list-leave-active {
  transition: all ease-in-out 0.2s;
}
.drop-list-enter,
.drop-list-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
.drop-list-enter-to,
.drop-list-leave {
  opacity: 1;
  transform: translateY(0);
}
</style>
